/* eslint-disable max-len */
import * as React from 'react'
const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 48 48" {...props}>
    <path
      fill="#000"
      fillRule="nonzero"
      d="m24 4 17 5.714v17.143C41 36.325 33.389 44 24 44S7 36.325 7 26.857V9.714L24 4Zm-.001 4.219L11 12.589v14.268c0 7.162 5.663 12.975 12.693 13.14L24 40c7.172 0 13-5.877 13-13.143V12.59l-13.001-4.37Zm9.559 10.029.132.133c.57.598.562 1.546-.019 2.133l-9.879 9.981a1.502 1.502 0 0 1-2.134 0l-5.667-5.714a1.616 1.616 0 0 1-.151-2.267 1.584 1.584 0 0 1 2.248-.152l4.628 4.667 8.707-8.781a1.502 1.502 0 0 1 2.135 0Z"
    />
  </svg>
)
export default SvgComponent
